<template>
    <section class="works-box" @submit.native.prevent>
        <div class="title_wrap">
            <span class="title_name">作品修改</span>
        </div>
        <div class="box-info box-info-inline" >
            <span style="color: red">注意：1、 图纸、任务书中不得出现学校、个人信息；2、 本次新人赛不接受合作作业；3、本次新人赛不接受已经在其他竞赛中获奖的作品；4、接受本科一至三年级作业，且须为本教学年度（2023-2024）作品!
            </span>
        </div>
        <div class="box-info box-info-inline" >
            <label class="label-inline">参赛组别：</label>
            <span>{{convertGrade(work.gid)}}</span>
        </div>
        <div class="box-info box-info-inline" >
            <label class="label-inline">作品名称：</label>
            <el-input disabled class="box-info el-input-mid" v-model="work.name" placeholder="请输入作品名称"></el-input>
        </div>

        <div class="box-info box-info-inline">
          <label class="label-inline">指导老师：</label>
          <el-input disabled class="box-info" v-model="work.teacher" placeholder="指导老师（多个老师以；分割）"></el-input>
        </div>
        <div class="box-info label-block">指导老师点评：</div>
        <el-input disabled class="box-info box-info-textarea" rows=5 type="textarea" maxlength="300" show-word-limit v-model="work.teacher_comment" placeholder="请输入指导老师点评（ 不超过300个字）"></el-input>


        <div class="box-info label-block">作品设计说明：</div>
       
        <el-input class="box-info box-info-textarea" type="textarea" rows=8 minlength="200" maxlength="1000" show-word-limit v-model="work.note" placeholder="作品设计说明，表达设计思路或设计理念（ 不少于200字，不多于1,000个字）"></el-input>
     

        <div class="box-info label-block">作品封面上传：</div>
        
        <el-upload
              class="works-up box-info"
              :class="{coverDisabled: coverIsMax}"
              :action="url+'/api/upload/json/'"
              :headers="headers"
              list-type="picture-card"
              :limit="1"
              accept="image/jpeg,image/png,image/jpg"
              :file-list="coverList"
              :on-success="handleSuccess.bind(this, 'cover')"
              :on-error="handleError.bind(this, 'cover')"
              :on-change="handleChange.bind(this, 'cover')"
              :on-remove="handleRemove.bind(this, 'cover')"
              :on-preview="handleCoverPreview"
              :before-upload="beforeUpload">
              <i class="el-icon-plus"></i>
              <div class="el-upload__text" v-if="work.channel === '2'"><i style="font-size:13px">上传作品封面</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG/PNG格式，大小不超过400K<br>尺寸要求为800x600px （横版）</i></div>
              <div class="el-upload__text" v-else><i style="font-size:13px">上传作品封面</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG格式，大小不超过1M<br>尺寸要求为2000x2000像素</i></div>
        </el-upload>
        <el-dialog :visible.sync="dialogCoverVisible">
              <img width="100%" :src="dialogCoverUrl" alt="">
        </el-dialog>

        <div class="box-info label-block">作品任务书上传：</div>
        <el-upload
              class="works-up box-info"
              :class="{specDisabled: specIsMax}"
              :action="url+'/api/upload/json/'"
              :headers="headers"
              list-type="picture-card"
              :limit="1"
              disabled
              accept="image/jpeg,image/png,image/jpg"
              :file-list="specList"
              :on-success="handleSuccess.bind(this, 'spec')"
              :on-error="handleError.bind(this, 'spec')"
              :on-change="handleChange.bind(this, 'spec')"
              :on-remove="handleRemove.bind(this, 'spec')"
              :on-preview="handleSpecPreview"
              :before-upload="beforeImageUpload">
              <i class="el-icon-plus"></i>
              <div class="el-upload__text"><i style="font-size:13px">上传作品任务书</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG/PNG格式，大小不超过2M<br>尺寸小于4000x4000</i></div>
        </el-upload>
        <el-dialog :visible.sync="dialogSpecVisible">
              <img width="100%" :src="dialogSpecUrl" alt="">
        </el-dialog>

        <div class="box-info label-block">作品图纸上传：</div>
        <div style="font-size: 18px;" >2~5张图纸：</div> 
        <el-upload
              class="works-up box-info"
              :class="{imageDisabled: imageIsMax}"
              :action="url+'/api/upload/json/'"
              :headers="headers"
              list-type="picture-card"
              :limit="6"
              accept="image/jpeg,image/png,image/jpg"
              :file-list="imgsList"
              :on-preview="handlePictureCardPreview"
              :on-success="handleSuccess.bind(this, 'image')"
              :on-error="handleError.bind(this, 'image')"
              :on-change="handleChange.bind(this, 'image')"
              :on-remove="handleRemove.bind(this, 'image')"
              :on-exceed="handleImageExceed.bind(this, 'image')" 
              :before-upload="beforeImageUpload">
              <i class="el-icon-plus"></i>
              <div class="el-upload__text"><i style="font-size:13px">上传图纸图片</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG格式，大小不超过2M</i></div>
<!--
              <div v-if="work.channel === '2'" class="el-upload__text"><i style="font-size:13px">上传图纸图片</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG格式，大小不超过2M</i></div>
              <div v-else class="el-upload__text"><i style="font-size:13px">上传作品图片</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG/PNG格式，大小不超过2M<br>尺寸小于4000x4000px<br>最多可上传4张</i></div>
-->
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <!-- 赛道二才需要上传实体模型照片 -->
        <template> 
        <div style="font-size: 18px;">1~2张实体模型照片：</div> 
        <el-upload
              class="works-up box-info"
              :class="{imageDisabled: image2IsMax}"
              :action="url+'/api/upload/json/'"
              :headers="headers"
              list-type="picture-card"
              :limit="2"
              accept="image/jpeg,image/png,image/jpg"
              :file-list="imgs2List"
              :on-preview="handlePictureCardPreview"
              :on-success="handleSuccess.bind(this, 'image2')"
              :on-error="handleError.bind(this, 'image2')"
              :on-change="handleChange.bind(this, 'image2')"
              :on-remove="handleRemove.bind(this, 'image2')"
              :on-exceed="handleImageExceed.bind(this, 'image2')" 
              :before-upload="beforeImageUpload">
              <i class="el-icon-plus"></i>
              <div class="el-upload__text"><i style="font-size:13px">上传实体模型图片</i>（<i style="color: red; font-size: 13px">必填</i>）<br><i style="font-size:11px">JPG格式，大小不超过2M</i></div>
        </el-upload>
        <el-dialog :visible.sync="dialogImage2Visible">
              <img width="100%" :src="dialogImage2Url" alt="">
        </el-dialog>
        </template> 


        <div class="box-info label-block">作品视频上传：</div>
        <el-upload
              class="works-up box-info video-works-up"
              :class="{videoDisabled: videoIsMax}"
              :action="url+'/api/upload/json/'"
              :headers="headers"
              list-type="picture-card"
              :limit="1"
              accept="video/mp4"
              :file-list="videosList"
              :on-success="handleSuccess.bind(this, 'video')"
              :on-error="handleError.bind(this, 'video')"
              :on-change="handleChange.bind(this, 'video')"
              :on-remove="handleRemove.bind(this, 'video')"
              :on-exceed="handleVideoExceed"
              :before-upload="beforeVideoUpload">
              <img src
              <i class="el-icon-plus"></i>
              <div class="el-upload__text"><i style="font-size:13px">上传作品视频</i>（<i style="font-size: 13px">选填</i>）<br><i style="font-size:11px">MP4格式，不超过100M<br>时长不超过2分钟</i></div>
        </el-upload>


        <div class="box-info box-info-inline" >
          <label class="label-inline-long">作品功能内容分类（<i style="color: red;">必填</i>）：</label>
          <el-select disabled class="cselect" v-model="work.audience" filterable placeholder="请选择">
            <el-option
            
              v-for="item in audiences"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
          <el-input disabled class="el-input-small" v-if="work.audience == '其他'" v-model="work.audienceOther" placeholder="请输入作品功能内容分类"></el-input>
          </div>
        
        <div class="box-info box-info-inline" >
          <label class="label-inline-long">作品地形环境分类（<i style="color: red;">必填</i>）：</label>
          <el-select disabled class="cselect" v-model="work.env" filterable placeholder="请选择">
            <el-option
              v-for="item in envs"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
          <el-input disabled class="el-input-small" v-if="work.env == '其他'" v-model="work.envOther" placeholder="请输入作品地形环境分类"></el-input>
          
        
        </div>
        <div class="box-info box-info-inline" >
          <label class="label-inline-long">作品针对面积分类（<i style="color: red;">必填</i>）：</label>
          <el-select disabled class="cselect" v-model="work.area" filterable placeholder="请选择">
            <el-option
              v-for="item in areas"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
          <el-input disabled class="el-input-small" v-if="work.area == '其他'" v-model="work.areaOther" placeholder="请输入作品面积分类"></el-input>
        
        </div>

        <el-button class="primary-btn" @click="save">确定修改</el-button>
      </section>
</template>

<script>
import { Loading } from 'element-ui'
import axios from 'axios'

export default {
  data () {
    return {
      url: this.API,
      token: '',
      wid: '',
      baseUrl: this.API + 'assets/upload/',
      audiences: [{
        value: '1', label: '展览'
      }, {
        value: '2', label: '活动中心（城市综合体）'
      }, {
        value: '3', label: '居住类'
      }, {
        value: '4', label: '景观建筑'
      }, {
        value: '5', label: '空间小品'
      }, {
        value: '6', label: '工作室'
      }, {
        value: '7', label: '教育建筑（学校/幼儿园）'
      }, {
        value: '8', label: '大空间场馆类'
      }, {
        value: '9', label: '观演建筑'
      },
        { 
        value: '10', label: '其他'
      } ],
      envs: [{
      // 山地、滨水、临水、历史街区、改扩建、复杂城市环境、乡村环境、大自然环境、无明显特征
        value: '1', label: '山地'
      }, {
        value: '2', label: '滨水'
      }, {
        value: '3', label: '临水'
      }, {
        value: '4', label: '历史街区'
      }, {
        value: '5', label: '改扩建'
      }, {
        value: '6', label: '复杂城市环境'
      }, {
        value: '7', label: '乡村环境'
      }, {
        value: '8', label: '大自然环境'
      }, {
        value: '9', label: '无明显特征'
      },
        { 
        value: '10', label: '其他'
      }],
      areas: [{
        value: '1', label: '小品类（百平米内）'
      }, {
        value: '2', label: '小型（几百平米）'
      }, {
        value: '3', label: '中型（几千平米）'
      }, {
        value: '4', label: '小型建筑群落'
      },
      { 
        value: '10', label: '其他'
      }],
      dialogImageUrl: '',
      dialogVisible: false,
      dialogImage2Visible: false,
      dialogCoverUrl: '',
      dialogCoverVisible: false,
      dialogSpecUrl: '',
      dialogSpecVisible: false,
      imageIsMax: false,
      image2IsMax: false, // 实体模型
      
      videoIsMax: false,
      coverIsMax: false,
      
      specIsMax: false,
      showFileUpload: true,
      work: {
        // 基本信息，每个类别都需要
        name: '',
        gid: '',
        coflag: '',
        coworker: '',
        teacher: '',
        teacher_comment: '',
        note: '',
        cover: '',
        spec: '',
        video: '',
        audience: '', // 功能内容
        env: '', // 地形环境
        area: '', // 面积
      },
      coverList: [],
    
      specList: [],
      imgsList: [],
      imgs2List: [],
      videosList: []
    }
  },
  computed: {
    headers: function () {
      let _t = this
      return {
        Token: _t.token
      }
    }
  },
  mounted () {
    let _t = this
    _t.token = _t.$ls.get('token')
    _t.wid = _t.$route.params.id
    _t._getData()
  },
  methods: {
    _getData: function () {
      let _t = this
      axios.post(_t.API + '/api/work/detail/', {token: _t.token, wid: _t.wid})
        .then(function (resp) {
          if (resp.data.code == '0') {
             _t.work = resp.data.data
             var imgs = _t.work.imgs_url.split(':')
             var imgsUrlArr = imgs[0] ? imgs[0].split(";") : [] 
             for (var i =0; i < imgsUrlArr.length; i++) {
               _t.imgsList.push({name: 'img'+i, url: _t.baseUrl + imgsUrlArr[i], file: imgsUrlArr[i]})
             }
             var imgs2UrlArr = imgs[1] ? imgs[1].split(";") : [] 
             for (var i =0; i < imgs2UrlArr.length; i++) {
               _t.imgs2List.push({name: 'img'+i, url: _t.baseUrl + imgs2UrlArr[i], file: imgs2UrlArr[i]})
             }
             if (imgsUrlArr.length >= 5) {
                _t.imageIsMax = true
             }
             if (imgs2UrlArr.length >= 2) {
                _t.image2IsMax = true
             }
          
             var videosUrlArr = _t.work.videos_url.trim(';').split(';')
             if (videosUrlArr.length >= 1 && videosUrlArr[0] != '') {
                _t.videoIsMax = true
                _t.work.video = videosUrlArr[0] 
                _t.videosList.push({name: 'video', url: _t.baseUrl + videosUrlArr[0], file: videosUrlArr[0]})
             }
             if (_t.work.cover != "" && _t.work.cover != undefined) {
                _t.coverIsMax = true
                _t.coverList.push({name: 'cover', url: _t.baseUrl + _t.work.cover, file: _t.work.cover})
             }
           
             if (_t.work.spec != "" && _t.work.spec != undefined) {
                _t.specIsMax = true
                _t.specList.push({name: 'spec', url: _t.baseUrl + _t.work.spec, file: _t.work.spec})
             }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleRemove: function (type, file, fileList) {
      console.log('type, file, fileList', type, file, fileList)
      let _t = this
      console.log('imgsList', _t.imgsList)
      console.log('imgs2List', _t.imgs2List)
      var fileName = file.file

      if (type === 'image') {
        // var maxLen = _t.work.channel === '2' ? 5 : 4
        var maxLen = 5
        if (fileList.length >= maxLen) {
          _t.imageIsMax = true
        } else {
          _t.imageIsMax = false
        }
        for(var i=0; i<_t.imgsList.length; i++) {
          if (fileName == _t.imgsList[i].file) {
            _t.imgsList.splice(i, 1)
            break;
          }
        }
        return
      }

      if (type === 'image2') {
        if (fileList.length >= 2) {
          _t.image2IsMax = true
        } else {
          _t.image2IsMax = false
        }
        for(var i=0; i<_t.imgs2List.length; i++) {
          if (fileName == _t.imgs2List[i].file) {
            _t.imgs2List.splice(i, 1)
            break;
          }
        }
        return
      }

      if (type === 'video') {
        _t.work.video = ''
        _t.videosList = []
        _t.videoIsMax = false
        return
      }

      if (type === 'cover') {
        _t.work.cover = ''
        _t.coverList = []
        _t.coverIsMax = false
        return
      }
   
      if (type === 'spec') {
        _t.work.spec = ''
        _t.specList = []
        _t.specIsMax = false
        return
      }
    },
    handleImageExceed: function (type, file, fileList) {
      if (type === 'image') {
        // var maxLen = _t.work.channel === '2' ? 5 : 4
        var maxLen = 5
        this.$messagewarning('最多上传'+maxLen+'张照片')
      } else if (type === 'image2') {
        this.$messagewarning('最多上传2张照片')
      }
    },
    handleVideoExceed: function (file, fileList) {
      this.$messagewarning('最多上传1个视频')
    },
    handlePictureCardPreview: function (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleCoverPreview: function (file) {
      this.dialogCoverUrl = file.url
      this.dialogCoverVisible = true
    },
    handleSpecPreview: function (file) {
      this.dialogSpecUrl = file.url
      this.dialogSpecVisible = true
    },
    handleError (type, err, file, fileList) {
      console.log(err)
    },
    handleChange (type, file, fileList) {
      let _t = this
      if (type === 'image') {
        // var maxLen = _t.work.channel === '2' ? 5 : 4
        var maxLen = 5
        if (fileList.length >= maxLen) {
          _t.imageIsMax = true
        } else {
          _t.imageIsMax = false
        }
        return
      }
 
      if (type === 'image2') {
        if (fileList.length >= 2) {
          _t.image2IsMax = true
        } else {
          _t.image2IsMax = false
        }
        return
      }
 
      if (type === 'video') {
        if (fileList.length >= 1) {
          _t.videoIsMax = true
        } else {
          _t.videoIsMax = false
        }
        return
      }

      if (type === 'cover') {
        if (fileList.length >= 1) {
          _t.coverIsMax = true
        } else {
          _t.coverIsMax = false
        }
        return
      }

      if (type === 'spec') {
        if (fileList.length >= 1) {
          _t.specIsMax = true
        } else {
          _t.specIsMax = false
        }
        return
      }
    },
    handleSuccess (type, res, file) {
      let _t = this
      _t.fullscreenLoading = false
      if (res.code === '401') {
        _t.$messagewarning('登录验证已失效，请重新登录')
        _t.$router.push('/login/')
        return
      }
      if (res.error === 1) {
        _t.$messageerror(res.message)
        return
      } else {
        if (type === 'image') {
          _t.imgsList.push({file: res.file, url: _t.baseUrl + res.file})
          return
        }
        console.log('before upload', _t.imgsList) 

        if (type === 'image2') {
          _t.imgs2List.push({file: res.file, url: _t.baseUrl + res.file})
          return
        }
        console.log('after upload', _t.imgs2List) 

        if (type === 'video') {
          _t.work.video = res.file
          _t.videosList.push({file: res.file, url: _t.baseUrl + res.file})
          return
        }

        if (type === 'cover') {
          _t.work.cover = res.file
          _t.coverList.push({file: res.file, url: _t.baseUrl + res.file})
          return
        }
      
        if (type === 'spec') {
          _t.work.spec = res.file
          _t.specList.push({file: res.file, url: _t.baseUrl + res.file})
          return
        }
      }
    },
    beforeImageUpload (file) {
      let _t = this
      let regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件')
        return false
      }
      if (!isLt2M) {
        this.$messagewarning('上传图片大小不能超过 2MB!')
        return false
      }
      
    },
    beforeUpload (file) {
      let _t = this
      let regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/
      const isLtSize = file.size / 1024 < 1000

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件')
        _t.coverIsMax = false
        return false
      }
      if (!isLtSize) {
        this.$messagewarning('上传图片大小不能超过1M!')
        _t.coverIsMax = false
        return false
      }
    },
    beforeFileUpload (file) {
      let _t = this

      let fileExt =file.name.substring(file.name.lastIndexOf('.')+1)
      if (fileExt != 'doc' && fileExt != 'docx') {
        _t.$messagewarning('请上传.doc, .docx类型文件')
        return false
      }

      const isLt5M = file.size / 1024 / 1024 < 2

      if (!isLt5M) {
        _t.$messagewarning('上传文件大小不能超过2MB!')
        return false
      }
    },
    beforeVideoUpload (file) {
      let _t = this
      const isLt100M = file.size / 1024 / 1024 < 100
      if (['video/mp4'].indexOf(file.type) === -1) { // 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'
        this.$messagewarning('请上传正确的视频格式')
        _t.videoIsMax = false
        return false
      }
      if (!isLt100M) {
        this.$messagewarning('上传视频大小不能超过100MB!')
        _t.videoIsMax = false
        return false
      }
    },
    validateInput: function () {
      let _t = this
      
       if (_t.work.note.length < 200) {
        _t.$messagewarning('作品设计说明不能小于200字')
        return
      }
      if (_t.work.note.length > 1000) {
        _t.$messagewarning('作品设计说明不能多于1000字')
      }
      if (_t.work.cover === '') {
        _t.$messagewarning('请上传作品封面')
        return
      }
      if (_t.imgsList.length < 2) {
        _t.$messagewarning('请上传至少2张作品图纸')
        return
      }
      // if (_t.work.channel === '2' && _t.imgs2List.length < 1) {
      if (_t.imgs2List.length < 1) {
        _t.$messagewarning('请上传至少1张作品实物模型图纸')
        return
      }

/*
      if (_t.work.name === '') {
        _t.$messagewarning('请输入作品名称')
        return
      }


      if (_t.work.teacher === '') {
        _t.$messagewarning('请输入指导老师姓名')
        return
      }
      if (_t.work.teacher_comment.length < 10) {
        _t.$messagewarning('指导老师点评不能小于10字')
        return
      }

      if (_t.work.spec === '') {
        _t.$messagewarning('请上传任务书')
        return
      }

      if (_t.work.audience == '') {
        _t.$messagewarning('请选择作品功能内容类别')
        return
      }
      if (_t.work.env == '') {
        _t.$messagewarning('请选择作品地形环境类别')
        return
      }
      if (_t.work.area == '') {
        _t.$messagewarning('请选择作品面积类别')
        return
      }
*/

      return true
    },
    save: function () {
      let _t = this
      if (_t.validateInput() != true) return

      var imgsUrl = ""
      for(var i=0; i<_t.imgsList.length; i++) {
          imgsUrl = imgsUrl + (i == 0 ? _t.imgsList[i].file : (";" + _t.imgsList[i].file))
      }
     
      // 两种不同图纸之间用:分割，同一种间用；分割 
      for(var i=0; i<_t.imgs2List.length; i++) {
          imgsUrl = imgsUrl + (i == 0 ? (":" + _t.imgs2List[i].file) : (";" + _t.imgs2List[i].file))
      }
      
      let ld = Loading.service({'fullscreen': true, 'text': '数据提交中，请稍后'})
      let reqData = {}
      reqData = {
        token: _t.token, 
        id: _t.wid, 
        name: _t.work.name, 
        teacher: _t.work.teacher,
        teachercomment: _t.work.teacher_comment,
        spec: _t.work.spec,
        audience: _t.work.audience,
        env: _t.work.env,
        area: _t.work.area,
        file: _t.work.design_file,
        creativenote: _t.work.note, 
        cover: _t.work.cover, 
        imgsUrl: imgsUrl,
        video: _t.work.video,
     }
     axios.post(_t.API + '/api/work/updateworkdetail/', reqData)
       .then(function (resp) {
         if (resp.data.code === '0') {
           _t.$messagesuccess(resp.data.msg)
           _t.$router.push('/work/')
         } else {
           _t.$messagewarning(resp.data.msg)
           if (resp.data.code === '401') {
             _t.$router.push('/login/')
           }
         }
         ld.close()
       })
       .catch(function (error) {
         console.log(error)
         _t.$messageerror(error)
         ld.close()
       })
    },
    convertGrade (val) {
      let grades = ['一年级', '二年级', '三年级', '赛道二']
      return grades[parseInt(val) - 1];
    }
  }
}
</script>

<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.works-box{
  padding: 60px calc((100% - 1024px) / 2) 0;
}
.box-info {
    margin-top: 10px;
}
.box-info-textarea textarea{
    min-height: 200px !important;
}
.box-info .el-input, .box-info .el-select{
    width: 350px;
}
.box-info-inline {
  display: flex;
  align-items: center;
}
.label-inline {
  width: 200px;
  height: 40px;
  line-height: 40px;
}
.label-block{
  margin-top: 20px;
}
.label-inline-long {
  width: 250px;
  height: 40px;
  line-height: 40px;
}
.primary-btn {
  width: 200px;
  margin: 20px 0;
  border-radius: 4px;
}
</style>
<style lang='stylus'>
@import '~@/common/stylus/index'

.works-up .el-upload-list {
    padding: 0;
    list-style: none;
}
.works-up .el-upload-list--picture-card {
    margin: 0;
    display: inline;
    vertical-align: top;
}
.works-up .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 300px;
    height: 225px;
    line-height: 1.5;
    margin: 0 8px 8px 0;
    display: inline-block;
}
.works-up .el-upload {
    display: inline-block;
    text-align: center;
    outline: none;

}
.works-up .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 300px !important;
    height: 225px !important;
    line-height: 1.5;
    cursor: pointer;
    vertical-align: top;
    display: inline-block;
}
.works-up .el-upload--picture {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 300px;
    height: 225px;
    line-height: 1.5;
    cursor: pointer;
    vertical-align: top;
    display: inline-block;
}
.works-up .el-icon-plus {
    font-size: 28px;
    color: #fff !important;
    border-radius: 50%;
    background-color: $color-dark-blue;
    position: relative;
    top: 80px;
}
.works-up .el-upload__text {
    position: relative;
    top: 100px;
    color: #a3a3a3;
}
.imageDisabled .el-upload--picture-card {
    display: none
}


.videoDisabled .el-upload--picture-card {
    display: none
}
.coverDisabled .el-upload--picture-card {
    display: none
}
.specDisabled .el-upload--picture-card {
    display: none
}
.video-works-up .el-upload-list__item-thumbnail {
    display: none;
}
.video-works-up .el-upload-list__item-name {
    display: block;
    position: relative;
    top: 80px;
}
.el-input-small {
    margin-left: 20px;
    width: 250px;
    }
</style>



// WEBPACK FOOTER //
// WorkDetailUpdate.vue?bac14fb4